module.exports = __webpack_public_path__ + "img/photo-0124.c6a0fe98.jpg";